import { render, staticRenderFns } from "./CustomProductsList.vue?vue&type=template&id=bafe7f24&"
import script from "./CustomProductsList.vue?vue&type=script&lang=js&"
export * from "./CustomProductsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports